export const orderHistoryTexts = {
  title: 'Minhas ordens',
  description: 'Mantenha o controle do andamento das suas ordens.',
  containerTitle: 'Histórico de ordens',
};
